<template>
    <div class="maintaindetail">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: 'mydevice' }">我的设备</el-breadcrumb-item>
            <el-breadcrumb-item @click.native="back" class="bold cursor">维护记录</el-breadcrumb-item>
            <el-breadcrumb-item>记录详情</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider />
        <div class="main">
            <div class="fr ac mt20 add_cell">
                <p class="fs device_name">记录类型:</p>
                <el-input
                    size="mini"
                    class="ml20 right"
                    :value="maintain_detail.record_type == '2'?'保养记录':'安装记录'"
                    disabled
                ></el-input>
            </div>
            <div class="fr ac mt20 add_cell" v-if="maintain_detail.record_type == '2'">
                <p class="fs device_name">保养内容:</p>
                <el-input
                    size="mini"
                    class="ml20 right"
                    :value="maintain_detail.record_desc"
                    disabled
                ></el-input>
            </div>
            <div
                class="fr ac mt20 add_cell"
                v-if="maintain_detail.record_type == '2' && maintain_detail.record_imgs.length"
            >
                <p class="fs device_name">图片:</p>
                <div class="fr ml20 right fw">
                    <el-image
                        :src="i"
                        v-for="(i,k) in maintain_detail.record_imgs.split(',')"
                        :key="k"
                        class="mr10 main_img"
                        :preview-src-list="maintain_detail.record_imgs.split(',')"
                    />
                </div>
            </div>
            <div class="fr ac mt20 add_cell" v-if="maintain_detail.record_type == '1'">
                <p class="fs device_name">产品编号:</p>
                <el-input
                    size="mini"
                    class="ml20 right"
                    :value="maintain_detail.order_goods_no"
                    disabled
                ></el-input>
            </div>
            <div class="fr ac mt20 add_cell" v-if="maintain_detail.record_type == '1'">
                <p class="fs device_name">产品名称:</p>
                <el-input
                    size="mini"
                    class="ml20 right"
                    :value="maintain_detail.record_desc"
                    disabled
                ></el-input>
            </div>
            <div
                class="fr ac mt20 add_cell"
                v-if="maintain_detail.record_type == '1' && maintain_detail.is_offline == '0'"
            >
                <p class="fs device_name"></p>
                <el-button size="mini" class="ml20" type="primary" @click="offDeviceRecord">皮带下机</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import UpLoad from "@/components/UploadImg";
export default {
    props: {},
    data() {
        return { maintain_detail: {} };
    },
    created() {
        this.getDeviceRecordDetail();
    },
    methods: {
        offDeviceRecord() {
            this.post("companyInterfaces/v1.0/offDeviceRecord", {
                device_record_id: this.maintain_detail.device_record_id
            }).then(res => {
                this.$message({
                    type: "success",
                    message: res.data
                });
                this.getDeviceRecordDetail();
            });
        },
        // 获取详情
        getDeviceRecordDetail() {
            this.post("companyInterfaces/v1.0/getDeviceRecordDetail", {
                device_record_id: this.$route.query.id
            }).then(res => {
                this.maintain_detail = res.data;
            });
        }
    }
};
</script>

<style scoped lang="scss">
.maintaindetail {
    font-size: 14px;
    .main {
        .add_cell {
            width: 40%;
            .device_name {
                width: 100px;
                text-align: right;
            }
            .right {
                width: calc(100% - 100px);
                .main_img {
                    width: 80px;
                    height: 80px;
                    margin-bottom: 10px;
                    flex-shrink: 0;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/me/myDevice/maintainDetail.vue